<template>
	<div class="search_detail_wrap">
		<div class="date_range">
			<ul>
				<li @click="changeSearchDate('today')">
					{{ $t('merchant_management.payment_list.modal.date1') }}
				</li>
				<li @click="changeSearchDate('yesterday')">
					{{ $t('merchant_management.payment_list.modal.date2') }}
				</li>
				<li @click="changeSearchDate('1month')">
					{{ $t('merchant_management.payment_list.modal.date3') }}
				</li>
				<li @click="changeSearchDate('3month')">
					{{ $t('merchant_management.payment_list.modal.date4') }}
				</li>
				<li @click="changeSearchDate('6month')">
					{{ $t('merchant_management.payment_list.modal.date5') }}
				</li>
			</ul>
		</div>
		<div class="d_flex mb_16">
			<div class="mr_8">
				<date-picker
					is-required
					v-model="startDate"
					:model-config="{ type: 'string' }"
					:locale="$store.state.common.locale"
				>
					<template v-slot="{ inputValue, inputEvents }">
						<label class="calendar_area">
							<input
								class="px-2 py-1 border rounded focus:outline-none focus:border-blue-300"
								:value="inputValue"
								v-on="inputEvents"
							/>
						</label>
					</template>
				</date-picker>
			</div>
			<div class="info">
				<date-picker
					is-required
					v-model="endDate"
					:model-config="{ type: 'string' }"
					:locale="$store.state.common.locale"
				>
					<template v-slot="{ inputValue, inputEvents }">
						<label class="calendar_area">
							<input
								class="px-2 py-1 border rounded focus:outline-none focus:border-blue-300"
								id="calendar_area"
								:value="inputValue"
								v-on="inputEvents"
							/>
						</label>
					</template>
				</date-picker>
			</div>
		</div>
		<div class="tal">
			<div class="mb_16">
				<p class="input_label">
					{{ $t('merchant_management.payment_list.detail.payment_assets') }}
				</p>
				<div class="select_area">
					<select v-model="selectedAsset">
						<option value="">
							{{ $t('input.placeholder.select_assets') }}
						</option>
						<option
							:value="item.asset_seq"
							v-for="item in settlementAccounts"
							:key="item.seq"
						>
							{{ item.asset_code }}
						</option>
					</select>
					<span class="select_icon"></span>
				</div>
			</div>
			<!--			<div class="mb_16">-->
			<!--				<p class="input_label">결제 유형</p>-->
			<!--				<div class="select_area">-->
			<!--					<select v-model="selectedPaymentType">-->
			<!--						<option value="" selected>결제 유형을 선택하세요.</option>-->
			<!--						<option :value="item.value" v-for="item in paymentType" :key="item">-->
			<!--							{{ item.name }}-->
			<!--						</option>-->
			<!--					</select>-->
			<!--					<span class="select_icon"></span>-->
			<!--				</div>-->
			<!--			</div>-->
			<!--			<div class="">-->
			<!--				<p class="input_label">결제자</p>-->
			<!--				<div class="search_area">-->
			<!--					<input-->
			<!--						type="text"-->
			<!--						v-model="searchKeyword"-->
			<!--						@input="inputName"-->
			<!--						placeholder="이름을 검색하세요."-->
			<!--					/>-->
			<!--					<a class="search_icon SEARCH"></a>-->
			<!--				</div>-->
			<!--			</div>-->
			<button class="merchant_button bg_red mt_40" @click="sendSearchDataForm">
				{{ $t('button.check') }}
			</button>
		</div>
	</div>
</template>

<script>
import { fetchMerchantAccountList } from '@/api/pg';
import { commonError } from '@/common/dialog';

export default {
	name: 'DetailSearchComponent',
	emits: ['searchData'],
	data() {
		return {
			startDate: this.$dayjs(new Date()).add(0, 'day').toDate(),
			endDate: new Date(),
			settlementAccounts: [],
			selectedAsset: '',
			// selectedPaymentType: '',
			// paymentType: [
			// 	{ name: 'PAYMENT', value: 'PAYMENT' },
			// 	{ name: 'REFUND', value: 'REFUND' },
			// ],
			// searchTarget: 'user_name',
			// searchKeyword: '',
			searchData: [],
		};
	},
	methods: {
		init() {
			this.loadSettlementAccountList();
		},
		changeSearchDate(e) {
			if (e === 'today') {
				this.startDate = this.$dayjs(new Date()).add(0, 'day').toDate();
			} else if (e === 'yesterday') {
				this.startDate = this.$dayjs(new Date()).add(-1, 'day').toDate();
			} else if (e === '1month') {
				this.startDate = this.$dayjs(new Date()).add(-1, 'month').toDate();
			} else if (e === '3month') {
				this.startDate = this.$dayjs(new Date()).add(-3, 'month').toDate();
			} else if (e === '6month') {
				this.startDate = this.$dayjs(new Date()).add(-6, 'month').toDate();
			}
		},
		async loadSettlementAccountList() {
			const { data } = await fetchMerchantAccountList(
				this.$route.params.merchant_seq,
			).catch(commonError);
			this.settlementAccounts = data;
		},
		inputName(e) {
			this.searchKeyword = e.target.value;
		},
		sendSearchDataForm() {
			let regdate_start = '';
			let regdate_end = '';
			let asset_seq = '';
			if (this.startDate) {
				regdate_start = this.startDate;
			}
			if (this.endDate) {
				regdate_end = this.endDate;
			}
			if (this.selectedAsset) {
				asset_seq = this.selectedAsset;
			}
			const params = {
				...this.$route.query,
				...this.$route.params,
				regdate_start: regdate_start,
				regdate_end: regdate_end,
				asset_seq: asset_seq,
			};
			this.$emit('searchData', params);
		},
	},
	created() {
		this.init();
	},
};
</script>

<style scoped></style>
